"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "paularo": {
    "72e8f32b": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "skipSearch": false
    }],
    "casaso": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "834fd0b3": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "skipSearch": false
    }],
    "castoia": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6b5766fc": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "skipSearch": false
    }],
    "lambrugno": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fd097f1c": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "skipSearch": false
    }],
    "misincinis": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c1ddde0": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "skipSearch": false
    }],
    "rio": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4add4ab7": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "skipSearch": false
    }],
    "tavella": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "18269172": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "skipSearch": false
    }],
    "villafuori": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa19ca5f": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "skipSearch": false
    }],
    "villamezzo": [{
      "hkey": "01a80ee7",
      "slug": "paularo",
      "name": "Paularo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;